export enum PremiumPaymentType {
  Insured = 'Self',
  AnotherPerson = 'Other'
}
